__webpack_require__.p = "https://techminds.pstatic.net/pkgtour/statics/vertical-v2/f0285cfa757f19c12a2ca7ffae5de1de7a42cba6/_next/";